import { useSearchParams } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { GitCommit, Cpu, FlaskConical, Activity, Music, Mic, Mail } from 'lucide-react'
import AdminCommitsPage from '@/routes/admin/commits/index'
import AdminModelConfigPage from '@/routes/admin/model-config/index'
import AdminSandboxPage from '@/routes/admin/sandbox/index'
import AdminActivityPage from '@/routes/admin/activity/index'
import AdminMusiclistPage from '@/routes/admin/musiclist/index'
import AdminVoiceLabPage from '@/routes/admin/voice-lab/index'
import AdminSupportPage from '@/routes/admin/support/index'

const tabTriggerClass = "relative px-5 py-3 text-sm font-medium text-neutral-400 hover:text-neutral-600 hover:bg-neutral-200/60 transition-colors rounded-none rounded-t-lg shadow-none bg-transparent data-[state=active]:bg-neutral-50 data-[state=active]:text-neutral-900 data-[state=active]:shadow-none data-[state=active]:border data-[state=active]:border-neutral-400 data-[state=active]:border-b-neutral-50 data-[state=active]:-mb-px gap-2"

export default function AdminDevelopersPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get('tab') || 'music'

  return (
    <div className="p-6 h-full flex flex-col">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-neutral-900">App Management</h1>
        <p className="text-sm text-neutral-500 mt-1">
          Support, infra, content libraries, dev tooling, and sandbox
        </p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(value) => setSearchParams({ tab: value })}
        className="flex-1 flex flex-col min-h-0"
      >
        <TabsList className="w-full h-auto p-0 bg-neutral-50 rounded-none border-b border-neutral-400 justify-start gap-0 mb-6">
          <TabsTrigger value="music" className={tabTriggerClass}>
            <Music className="h-4 w-4" />
            Music Library
          </TabsTrigger>
          <TabsTrigger value="voice-lab" className={tabTriggerClass}>
            <Mic className="h-4 w-4" />
            Voice Lab
          </TabsTrigger>
          <TabsTrigger value="support" className={tabTriggerClass}>
            <Mail className="h-4 w-4" />
            Support
          </TabsTrigger>
          <TabsTrigger value="activity" className={tabTriggerClass}>
            <Activity className="h-4 w-4" />
            Activity
          </TabsTrigger>
          <TabsTrigger value="git-deploy" className={tabTriggerClass}>
            <GitCommit className="h-4 w-4" />
            GitHub & Deployments
          </TabsTrigger>
          <TabsTrigger value="model-config" className={tabTriggerClass}>
            <Cpu className="h-4 w-4" />
            Model Configuration
          </TabsTrigger>
          <TabsTrigger value="sandbox" className={tabTriggerClass}>
            <FlaskConical className="h-4 w-4" />
            Sandbox
          </TabsTrigger>
        </TabsList>

        <TabsContent value="support" className="flex-1 min-h-0 mt-0 -mx-6 -mb-6">
          <AdminSupportPage />
        </TabsContent>

        <TabsContent value="activity" className="flex-1 min-h-0 mt-0 -mx-6 -mb-6">
          <AdminActivityPage />
        </TabsContent>

        <TabsContent value="git-deploy" className="flex-1 min-h-0 mt-0">
          <AdminCommitsPage />
        </TabsContent>

        <TabsContent value="model-config" className="flex-1 min-h-0 mt-0">
          <AdminModelConfigPage />
        </TabsContent>

        <TabsContent value="sandbox" className="flex-1 min-h-0 mt-0">
          <AdminSandboxPage embedded />
        </TabsContent>

        <TabsContent value="music" className="flex-1 min-h-0 mt-0 -mx-6 -mb-6">
          <AdminMusiclistPage />
        </TabsContent>

        <TabsContent value="voice-lab" className="flex-1 min-h-0 mt-0 -mx-6 -mb-6">
          <AdminVoiceLabPage />
        </TabsContent>
      </Tabs>
    </div>
  )
}
